import { render, staticRenderFns } from "./configuration-automation-assays-modal-basic-form.vue?vue&type=template&id=332e802c&"
import script from "./configuration-automation-assays-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-assays-modal-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports